<template>
	<div id="preview" class="w-full h-full flex flex-col">

		<template v-if="!error">

			<slot name="header">

				<div style="height: 50px" class="bg-grey-lighter flex items-center px-2 justify-between">

					<div v-if="!recargar && implementado" class="flex align-center">

						<template v-if="!loading">

							<span class="text-xl font-bold text-grey-darker c-pointer"><fa icon="search-minus"/></span>

							<input class="mx-1" type="range" min="1" max="3" step="0.1" v-model="zoom">

							<span class="text-xl font-bold text-grey-darker c-pointer"><fa icon="search-plus"/></span>

						</template>

					</div>

					<div v-if="!recargar && implementado" class="flex items-center">

						<button
							class="text-grey-darker p-2 font-bold text-xl focus:outline-none"
							:disabled="paginador.pagina <= 1"
							@click="anterior"
						>

							<fa icon="chevron-left"/>

						</button>

						<div class="text-primary font-bold text-xl">{{ paginador.pagina }}</div>

						<button
							class="text-grey-darker p-2 font-bold text-xl focus:outline-none"
							:disabled="paginador.pagina >= paginador.paginas"
							@click="siguiente"
						>

							<fa icon="chevron-right"/>

						</button>

					</div>

					<div v-else-if="recargar && implementado" class="flex items-center">

						<button
							title="Recargar"
							class="text-grey-darker p-2 font-bold text-xl focus:outline-none"
							@click="cargarPreview(true)"
						>

							<fa icon="sync"/>

						</button>

					</div>

				</div>

			</slot>

			<div ref="contenedor" class="relative h-full overflow-hidden">

				<canvas
					v-show="!loading"
					class="absolute"
					ref="canvas"
					:style="{
					'transform-origin': 0 + 'px ' + 0  + 'px',
					'transform': `scale(${scale}) translate(${x}px, ${y}px)`,
					'top': 0,
				}"
				></canvas>

				<div v-if="loading" class="spinner-center xl"></div>

			</div>

		</template>

		<div v-else>

			<div style="height: 50px" class="bg-grey-lighter flex items-center px-2">

				<button
					v-if="close"
					class="py-2 px-4 relative click focus:outline-none ml-auto text-xl"
					@click="$emit('closePreview')"
				>

					<fa class="text-grey-darker" icon="times"></fa>

				</button>

			</div>

			<h3 class="p-3">No existe vista previa</h3>

		</div>

	</div>
</template>

<script>
	import Hammer from 'hammerjs'
	import { previsualizarElemento, recargarPrevisualizarElemento } from '@/helpers/api'

	export default {
		name: 'Preview',
		props: {
			currentObject: Object,
			close: {
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				hammerCargado: false,
				x: 0,
				y: 0,
				lastX: 0,
				lastY: 0,
				originalScale: 1,
				scale: 1,
				currentZoom: 1,
				loading: false,
				error: false,
				zoom: 1,
				paginador: {
					pagina: 1,
					paginas: 1
				},
				recargar: false,
				implementado: true
			}
		},
		watch: { zoom (val) { this.changeZoom(val) } },
		mounted () { this.cargarPreview() },
		methods: {

			anterior () {

				this.paginador.pagina--

				this.cargarPreview()

			},

			async cargarPreview (recargar = false) {

				if (this.loading) return

				this.loading = true

				this.error = false

				this.zoom = 1

				try {

					let data = {}

					if (recargar) data = await recargarPrevisualizarElemento(this.currentObject.id, this.paginador.pagina)

					else data = await previsualizarElemento(this.currentObject.id, this.paginador.pagina)

					data = data.data

					const image = new Image()

					this.paginador = {
						pagina: data.pagina,
						paginas: data.paginas
					}

					this.recargar = data.recargar

					this.implementado = data.implementado

					image.crossOrigin = 'anonymous'

					image.src = `data:image/jpeg;base64,${ data.preview }`

					image.addEventListener('load', () => {

						this.$refs.canvas.width = image.width

						this.$refs.canvas.height = image.height

						this.originalScale = parseInt(getComputedStyle(this.$refs.contenedor).getPropertyValue('width')) / this.$refs.canvas.width

						this.scale = this.originalScale

						this.$refs.canvas.getContext('2d').drawImage(image, 0, 0)

					})

					if (!this.recargar && this.implementado) this.iniciarHammer()

					this.loading = false

				} catch (err) {

					this.error = true

					this.loading = false

					throw err

				}

			},

			changeZoom (scale) {

				this.scale = this.originalScale * scale

				this.lastX = 0

				this.lastY = 0

				this.x = 0

				this.y = 0

				this.currentZoom = scale

			},

			iniciarHammer () {

				if (this.hammerCargado) return

				const mc = new Hammer.Manager(this.$refs.contenedor)

				const singlepan = new Hammer.Pan({
					event: 'pan',
					direction: Hammer.DIRECTION_ALL,
					threshold: 5,
					pointers: 1
				})

				const multipan = new Hammer.Pan({
					event: 'multipan',
					direction: Hammer.DIRECTION_ALL,
					threshold: 5,
					pointers: 2
				})

				mc.add(singlepan)

				mc.add(multipan)

				singlepan.recognizeWith(multipan)

				multipan.requireFailure(singlepan)

				mc.on('pan', ev => {

					this.x = -(this.lastX - ev.deltaX / this.scale)

					this.y = -(this.lastY - ev.deltaY / this.scale)

				})

				mc.on('panend', () => {

					this.lastX = -this.x

					this.lastY = -this.y

				})

				this.hammerCargado = true

			},

			siguiente () {

				this.paginador.pagina++

				this.cargarPreview()

			}

		}
	}
</script>

<style lang="scss" scoped>

	#preview {
		background-position: center center;
		background-size: contain;
		background-repeat: no-repeat
	}

	.slider::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 25px;
		height: 25px;
		background: #4CAF50;
		cursor: pointer;
	}


</style>
